import timg1 from '../images/team/team_member_image_1.webp'
import timg2 from '../images/team/team_member_image_2.webp'
import timg3 from '../images/team/team_member_image_3.webp'
import timg4 from '../images/team/team_member_image_4.webp'
import timg5 from '../images/team/team_member_image_5.webp'
import sudeevImg from '../images/team/Sudeev-1.jpeg'
import mohdImg from '../images/team/MOHD ZULHILMI SYAZWAN BIN MISRAN-1.jpeg'

const Teams = [
   {
      Id: '1',
      tImg: sudeevImg,
      name: 'SUDHEEV MADHAVAN',
      slug: 'SUDHEEV-MADHAVAN',
      title: 'Founder',
      experience: '8+ Years',
      email: 'leadership@kritcloudplatforms.com',
   },
   {
      Id: '2',
      tImg: mohdImg,
      name: 'MOHD ZULHILMI',
      slug: 'MOHD-ZULHILMI',
      title: 'Cloud Solutions Architect',
      experience: '8+ Years',
      email: 'cloud@kritcloudplatforms.com',
   },
   {
      Id: '3',
      tImg: timg3,
      name: 'SYAZWAN BIN MISRAN',
      slug: 'SYAZWAN-BIN-MISRAN',
      title: 'Senior Software Engineer',
      experience: '7+ Years',
      email: 'software@kritcloudplatforms.com',
   },
   {
      Id: '4',
      tImg: timg4,
      name: 'KRISHNA',
      slug: 'KRISHNA',
      title: 'Cybersecurity Consultant',
      experience: '8+ Years',
      email: 'security@kritcloudplatforms.com',
   },
   {
      Id: '5',
      tImg: timg5,
      name: 'Marcus Tan',
      slug: 'Marcus-Tan',
      title: 'Data Analytics Lead',
      experience: '7+ Years',
      email: 'data@kritcloudplatforms.com',
   },
   {
      Id: '6',
      tImg: timg1,
      name: 'Siti Farah Aziz',
      slug: 'Siti-Farah-Aziz',
      title: 'Business Systems Consultant',
      experience: '7+ Years',
      email: 'business@kritcloudplatforms.com',
   },
   {
      Id: '7',
      tImg: timg2,
      name: 'James Walker',
      slug: 'James-Walker',
      title: 'IT Infrastructure Specialist',
      experience: '8+ Years',
      email: 'infrastructure@kritcloudplatforms.com',
   },
   {
      Id: '8',
      tImg: timg3,
      name: 'Mei Ling Chen',
      slug: 'Mei-Ling-Chen',
      title: 'UI/UX and Product Designer',
      experience: '7+ Years',
      email: 'product@kritcloudplatforms.com',
   },
   {
      Id: '9',
      tImg: timg4,
      name: 'Ravi Kumar',
      slug: 'Ravi-Kumar',
      title: 'AI and Automation Engineer',
      experience: '7+ Years',
      email: 'automation@kritcloudplatforms.com',
   },
   {
      Id: '10',
      tImg: timg5,
      name: 'Hannah Lee',
      slug: 'Hannah-Lee',
      title: 'Project Delivery Manager',
      experience: '8+ Years',
      email: 'delivery@kritcloudplatforms.com',
   },
]

export default Teams;
